document.addEventListener("DOMContentLoaded", function () {
  const toggleButton = document.getElementById("toggle-grid-images");

  let isAltView = localStorage.getItem("altViewEnabled") === "true";

  function applyAltViewToAll() {
    const productImages = document.querySelectorAll(".product-grid-item__image");
    productImages.forEach((image) => {
      if (isAltView) {
        image.classList.add("product-grid-item__image-altview");
      } else {
        image.classList.remove("product-grid-item__image-altview");
      }
    });

    if (toggleButton) {
      toggleButton.classList.toggle("active", isAltView);
    }
  }

  toggleButton?.addEventListener("click", function () {
    isAltView = !isAltView;
    localStorage.setItem("altViewEnabled", isAltView);
    applyAltViewToAll();
  });

  const observer = new MutationObserver(applyAltViewToAll);
  observer.observe(document.body, { childList: true, subtree: true });

  applyAltViewToAll();
});

